import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DetailDialogContent } from './+model/detail-dialog-content';

@Component({
    selector: 'ngf-detail-dialog',
    templateUrl: './detail-dialog.component.html',
    styleUrls: ['./detail-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DetailDialogComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: DetailDialogContent) {}
}
